import { Core } from "@faire/design-tokens";
import { ShowroomBadge } from "@faire/retailer-visitor-shared/components/Showroom/ShowroomBadge";
import { Tooltip } from "@faire/web/slate/Tooltip";
import { PortalTooltip } from "@faire/web/slate/Tooltip/PortalTooltip";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { trackApparelDiscoveryShowroomV2Click } from "@faire/web-api--source/events/apparelDiscovery/click/showroomV2";
import * as React from "react";

interface IProps {
  token?: string;
  customEventName?: string;
  tooltipZIndex?: number;
  className?: string;
  pointerOffset?: number;
}

export const ShowroomTileBadge: React.FC<IProps> = ({
  token,
  customEventName,
  tooltipZIndex,
  className,
  pointerOffset,
}) => {
  const { isTabletAndBelow } = useViewport();
  const onHover = () => {
    trackApparelDiscoveryShowroomV2Click(
      "badge-hover",
      token ?? "",
      customEventName ?? ""
    );
  };

  if (isTabletAndBelow) {
    return <ShowroomBadge small className={className} />;
  }

  return (
    <PortalTooltip
      tooltip={
        <Tooltip
          targetNode={<div />}
          colors={{ backgroundColor: Core.text.default }}
          position="bottom"
          pointerOffset={pointerOffset}
          isOpen
        >
          <Typography variant="paragraphSansRegular" color={Core.text.inverse}>
            <StrictLocalMsg defaultMessage="Showroom brands are carefully evaluated by Faire’s editorial team for quality fabric, fit, and construction." />
          </Typography>
        </Tooltip>
      }
      tooltipZIndex={tooltipZIndex}
      className={className}
      placement="bottom"
    >
      <ShowroomBadge onMouseEnter={onHover} small />
    </PortalTooltip>
  );
};
